export const ROOT_COLLECTION = 'heroes';
export const ETHERSCAN_TRANSACTION_URL =
  process.env.ETHERSCAN_TRANSACTION_URL || 'https://etherscan.io/tx/';
export const DISCORD_LINK = 'https://discord.gg/7sE2se2Z62';
export const EXCHANGE_LINK =
  'https://app.uniswap.org/tokens/mainnet/0x710Aa623c2c881b0d7357bCf9aEedf660E606C22';
export const EXCHANGE_LP_TOKEN_LINK =
  'https://app.sushi.com/add/ETH/0x710Aa623c2c881b0d7357bCf9aEedf660E606C22';
export const TWITTER_LINK = 'https://twitter.com/HeroesDotFun';
